import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import sanctumApi from '../services/api';
import './Setup.css';

const Setup = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    password: '',
    confirmPassword: ''
  });
  const [loading, setLoading] = useState(false);
  const [checking, setChecking] = useState(true);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const checkExistingAdmin = async () => {
      try {
        const { hasAdmin } = await sanctumApi.checkSetupStatus();
        if (hasAdmin) {
          // Admin exists, redirect to login
          navigate('/sanctum/login');
        } else {
          // No admin exists, show setup form
          setChecking(false);
        }
      } catch (error) {
        console.error('Error checking setup status:', error);
        // On error, show setup form
        setChecking(false);
      }
    };
    
    checkExistingAdmin();
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (formData.password !== formData.confirmPassword) {
      setError('Passwords do not match');
      return;
    }

    if (formData.password.length < 6) {
      setError('Password must be at least 6 characters');
      return;
    }

    setLoading(true);
    try {
      const response = await sanctumApi.setupFirstAdmin(
        formData.name,
        formData.email,
        formData.password
      );
      
      if (response.token) {
        navigate('/sanctum');
      }
    } catch (error) {
      setError(error.message || 'Failed to create admin');
    } finally {
      setLoading(false);
    }
  };

  if (checking) {
    return (
      <div className="setup-container">
        <div className="loading">Checking system status...</div>
      </div>
    );
  }

  return (
    <div className="setup-container">
      <div className="setup-box">
        <h1>Welcome to Sanctum</h1>
        <p className="setup-subtitle">
          Create your first administrator account to get started
        </p>
        
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="name">Full Name</label>
            <input
              type="text"
              id="name"
              value={formData.name}
              onChange={(e) => setFormData({...formData, name: e.target.value})}
              required
              placeholder="John Doe"
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              value={formData.email}
              onChange={(e) => setFormData({...formData, email: e.target.value})}
              required
              placeholder="admin@echo.com"
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              value={formData.password}
              onChange={(e) => setFormData({...formData, password: e.target.value})}
              required
              placeholder="••••••••"
              minLength={6}
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="confirmPassword">Confirm Password</label>
            <input
              type="password"
              id="confirmPassword"
              value={formData.confirmPassword}
              onChange={(e) => setFormData({...formData, confirmPassword: e.target.value})}
              required
              placeholder="••••••••"
            />
          </div>
          
          {error && <div className="error-message">{error}</div>}
          
          <button type="submit" className="setup-btn" disabled={loading}>
            {loading ? 'Creating Admin...' : 'Create Admin Account'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Setup;